import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import LoopIcon from '@mui/icons-material/Loop';
import DefaultHeading from '../../components/heading/DefaultHeading';
import "./JobsConfiguration.css";
import { ChannelkartNetworkGet, ChannelkartNetworkPut, ChannelkartNetworkDelete, ChannelkartNetworkPost } from '../../services/networkService';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { openPopup } from '../../stateManagement/actions/popupActions';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';

const JobsConfiguration = () => {

    const navigate = useNavigate();
    const [tableData, setTableData] = useState<Record<string, any>[]>([]);
    const [jobToBeDeleted, setJobToBeDeleted] = useState<string>("");

    const [confirmationPopUp, setConfirmationPopUp] = useState(false);

    const handleClickDeleteOpen = (name: string) => {
        setJobToBeDeleted(name);
        setConfirmationPopUp(true);
    };

    const createSchedular = async () => {
        navigate(`/dashboard/jobsConfiguration/schedularForm?type=create`);
    }

    const createIfNotExists = async () => {
        try {
            const url = `/jenkins/createifnotexists`
            await ChannelkartNetworkPost(url, "").then(
                () => { openPopup("Success", "The Information has been updated") }
            );
        } catch (error) {
            console.error(error);
        }
    }

    const getData = async () => {
        try {
            const url = `/jenkins?size=1000`
            const response = await ChannelkartNetworkGet(url);
            setTableData(response.data.features);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => { getData() }, []);

    const columns = [
        { field: 'jobName', headerName: 'Job Name', width: 580 },
        { field: 'discription', headerName: 'Description', width: 280 },
        {
            field: 'trigger',
            headerName: 'Triggering Time',
            width: 400,
            renderCell: (params: any) => (
                <div className="trigger_buttons" >
                    <Button className="customButton" variant="contained" onClick={() => handleEdit(params.row.id)}> EDIT JOB</Button>
                    <Button className="customButton" variant="contained" onClick={() => handleTrigger(params.row.id, params.row.jobName)}> TRIGGER</Button>
                    <Button className="customButton" variant="contained" onClick={() => handleAllResults(params.row.id, params.row.jobName)}> ALL RESULTS</Button>
                    <Button className="customButton" variant="contained" onClick={() => handleDisable(params.row.activeStatus, params.row.jobName)}> {params.row.activeStatus == "active" ? 'DISABLE JOB' : ' ENABLE JOB'}</Button>
                    <Button className="customButton" variant="contained" onClick={() => handleClickDeleteOpen(params.row.jobName)}> DELETE</Button>
                </div>
            ),
        },
    ];

    const handleEdit = (id: number) => {
        navigate(`/dashboard/jobsConfiguration/schedularForm?type=edit&job=${id}`);
    };

    const handleAllResults = (id: number, name: string) => {
        navigate(`/dashboard/jobsConfiguration/allResult?jobName=${name}`);
    };

    const handleDelete = async () => {
        try {
            const url = `/jenkins/${jobToBeDeleted}`
                validateWithOtp((verifyUser,verifyResponse)=>{
                    if (verifyResponse && verifyResponse.status === 201 && verifyResponse.status === 200) {
                        setTableData((prevRows) => {
                            return prevRows.filter((row: any) => row.jobName !== jobToBeDeleted) || [];
                        });
                        setJobToBeDeleted('');
                        openPopup("Success", "Deleted Successfully");
                    }else if (!verifyResponse || (verifyResponse.status !== 200 && verifyResponse.status !== 201)) {
                        throw new Error("OTP validation failed");
                    }else{
                        throw new Error("API call failed");
                    }
                },[],"admin",url,{},"DELETE");   // Need to check!
            }catch (error) {
            console.error(error);
            openPopup("Error", "Something went wrong during API call");
        }
    };
    const handleDisable = async (activeStatus: string, name: string) => {
        let status = activeStatus == "active" ? "disable" : "enable";
        try {
            const url = `/jenkins/${name}/${status}`
                validateWithOtp((verifyUser,verifyResponse)=>{
                    if (verifyResponse && verifyResponse.status === 201 && verifyResponse.status === 200) {
                        setTableData(
                            tableData.map((row: any) =>
                                row.jobName === name ? { ...row, activeStatus: status } : row
                            )
                        );
                    }else if (!verifyResponse || (verifyResponse.status !== 200 && verifyResponse.status !== 201)) {
                        throw new Error("OTP validation failed");
                    }else{
                        throw new Error("API call failed");
                    }
                },[],"admin",url,{},"PUT");
        } catch (error) {
            console.error(error);
        }
    };

    const handleTrigger = async (id: number, name: string) => {
        try {
            const url = `/jenkins/${name}/build`
            await ChannelkartNetworkPut(url, "");
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='jobs_configuration_container'>
            {
                <>
                    <DefaultHeading heading='Jobs Configuration' showDefaultBackButton={true} />
                    <div className='jobs_configuration_buttons'>
                        <div className='create_schedular_button'>
                            <Button variant="contained" onClick={createSchedular}><AddIcon /> CREATE SCHEDULAR</Button>
                        </div>
                        <div className='create_if_not_exists_button'>
                            <Button variant="contained" onClick={createIfNotExists}><LoopIcon />CREATE IF NOT EXISTS</Button>
                        </div>
                    </div>
                    <div style={{ height: 393, width: '100%' }}>
                        <DataGrid
                            rows={tableData}
                            columns={columns}
                        />
                    </div>
                    <ConfirmationPopUp
                        message={`Are you sure want to delete`}
                        openConfirmModal={confirmationPopUp}
                        successMethod={handleDelete}
                        setOpenConfirmModal={setConfirmationPopUp}
                    />
                </>
            }
        </div>
    )
}

export default JobsConfiguration